import ForceUnits from 'config/force-units';

export default function torqueUnitFor(lengthUnit) {
  return ForceUnits[lengthUnit.value == 'feet' ? 'ftlbs' : 'Nm'];
}
